import { ISelectOption } from "src/components/Forms/Select/types";
import { DictNode } from "src/types/CompanyInfo";

export const dict2Options = (dict: DictNode[]): ISelectOption<string>[] =>
  dict.map((e) => ({ label: e.value, value: e.key }));
